var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./projects_list_item.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-1c52c0f0\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./projects_list_item.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./projects_dropdown/components/projects_list_item.vue
// module id = ./projects_dropdown/components/projects_list_item.vue
// module chunks = main